import CampaignResultsTable from './CampaignResultsTable'
import { ResultsTableProps } from './interfaces'

const CampaignResultsTablePerFlag = (props: ResultsTableProps) => {
  return <CampaignResultsTable {...props} />
}

export default CampaignResultsTablePerFlag
